const initialState = {
    partnerList: [],
    s3filePath: '',
    status: '',
    statusMessage: '',
    loading: false,
    allPartners: [],
};

const downloadXLSXReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'genAi_ItineraryAssist_createXLSX': {
            return {
              ...state,
              s3filePath: '',
              status: '',
              statusMessage: '',
              loading: true
            };
        }
        case 'genAi_ItineraryAssist_createXLSX_SUCCESS': {
            return {
                ...state,
                s3filePath: action.payload && action.payload.length > 0 ? action.payload[0].s3filePath : '',
                status: action.payload && action.payload.length > 0 ? action.payload[0].status : 'failed',
                statusMessage: action.payload && action.payload.length > 0 ? action.payload[0].statusMessage : '',
                loading: false
            };
        }
        case 'genAi_ItineraryAssist_createXLSX_ERROR': {
            return {
                ...state,
                status: action.payload && action.payload.length > 0 ? action.payload[0].status : 'failed',
                statusMessage: action.payload && action.payload.length > 0 ? action.payload[0].statusMessage : '',
                loading: false
            };
        }
        case 'genAi_downloadXLSX_loadPartners_SUCCESS': {
            const partners = action.payload.partners;
            return {
                ...state,
                allPartners: partners
            };
        }
        case 'genAi_downloadXLSX_loadAllAppKeys_SUCCESS': {
            const appKeys = action.payload.userAppKeys;
            const allPartners = state.allPartners;
            const partnersWithAppKeys = allPartners.filter(partner => 
                appKeys.some(appKey => appKey.hint === partner.id)
            );
            const partnerListWithIntegrations = partnersWithAppKeys.map((partner) => {
                return {
                    id: partner.id,
                    name: partner.name,
                }
            });
            return {
                ...state,
                partnerList: partnerListWithIntegrations
            };
        }
        default:
        return state;
    }
};

export default downloadXLSXReducer;